'use client';

import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import siteTheme from '@/lib/theme';

const { fonts, colors } = siteTheme;
const LIMIT = 180;

export default function DescriptionExpand({ text }: { text: string }) {
  const [expanded, setExpanded] = useState(false);
  const needsTrunc = text.length > LIMIT;
  const display = needsTrunc && !expanded ? text.slice(0, LIMIT).trimEnd() + '…' : text;
  return (
    <div>
      <p style={{
        fontFamily: fonts.sans, fontSize: 'clamp(1.35rem,1.5vw,1.55rem)',
        fontWeight: 300, color: 'rgba(13,47,68,0.75)', lineHeight: 1.8,
      }}>
        {display}
      </p>
      {needsTrunc && (
        <button type="button" onClick={() => setExpanded(v => !v)} style={{
          marginTop: '0.6rem', background: 'none', border: 'none',
          cursor: 'pointer', padding: 0,
          display: 'inline-flex', alignItems: 'center', gap: '0.35rem',
          fontFamily: fonts.sans, fontSize: '1.2rem', fontWeight: 500,
          color: colors.gold, textDecoration: 'underline', textUnderlineOffset: '3px',
        }}>
          {expanded ? 'Show less' : 'Read more'}
          <ChevronDown size={12} color={colors.gold} strokeWidth={1.5}
            style={{ transition: 'transform 0.2s', transform: expanded ? 'rotate(180deg)' : 'none' }} />
        </button>
      )}
    </div>
  );
}
